import { ActionBarConfig } from './angie-action-bar/angie-action-bar.model';

export interface AngieFormSectionConfig {
	actionBarConfig: ActionBarConfig;
	className?: string;
	formSectionType?: FormSectionType;
}

export enum FormSectionType {
	STICKY,
	FIXED_HEIGHT
}
